<template>
	<div class="properties">
		<ul class="properties__list" :class="{ 'properties__list--three-columns': layout === 'grid', 'properties__list--one-by-one': layout === 'list' }">
			<li class="properties__item" v-for="property in properties">
				<span class="properties__label" v-if="property.status && property.status.attribute.slug!=='active'" :style='"background-image:url(\"/images/label-"+property.status.attribute.slug+"-"+lang+"-" + site + ".png\");"'>
				</span>
        <template v-if="property.listingMainPhoto">
          <a :href="property.url" class="properties__photo-link">
            <img class="func-properties-photo properties__photo" :src="property.listingMainPhoto">
          </a>
        </template>
			
				<div class="properties__informations">
					<h3 class="properties__title"><a :href="property.url">{{property.listingAddressIn}}</a></h3>
					<span class="properties__price">
             <template v-if='this.location.href.indexOf("staffhousing")==-1 && property.show_price==1'>
                    € {{ property.ah_price && property.ah_price.indexOf(',00') == -1 ? (property.ah_price.indexOf(',') != -1 ? property.ah_price : property.ah_price + ',-') : (property.ah_price ? property.ah_price.replace(',00', ',-') : '') }} {{locales.properties && locales.properties.a_month}} <span v-html='property.ah_price_includes_short'></span>
            </template>
            <template v-else-if='this.location.href.indexOf("staffhousing")==-1'>
                   {{locales.properties && locales.properties.price_on_request}}
            </template>
            <template v-else>
                    {{ property.max_people }} {{locales.properties && locales.properties.max_number_of_persons}}

            </template>
					</span>

					<div class="properties__features">
						<dl class="list">
						  <dt class="list__term">{{locales.properties && locales.properties.type}}</dt>
						  <dd class="list__definition">{{ property.type && property.type.value }}</dd>
						  <template v-if="property.no_bedrooms">
                <dt class="list__term">{{locales.properties && locales.properties.bedrooms}}</dt>
                <dd class="list__definition">{{ property.no_bedrooms }}</dd>
						  </template>
						  <template v-if="property.furnishingObject">
							  <dt class="list__term">{{locales.properties && locales.properties.interior}}</dt>
							  <dd class="list__definition">{{ property.furnishingObject.value }}</dd>
						  </template>
						  <dt class="list__term">{{locales.properties && locales.properties.available_on}}</dt>
						  <dd class="list__definition">{{property.available_on}}</dd>
						</dl>
					</div>

						  <template v-if="property.descriptionExcerpt">
                <p class="properties__caption" v-html='property.descriptionExcerpt'>
                </p>
						  </template>

					<a class="properties__button" @click='remove(property.id)'>
						{{locales.common && locales.common.remove}}
					</a>
				</div>
			</li>
		</ul>                        
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
import $ from 'jquery';
export default {
  computed: {
    ...mapGetters(['metadata', 'locales']),
    layout() {
      return this.$store.getters.getPropertiesLayout;
    },
    properties() {
      return this.$store.getters.getPropertiesCollection;
    }
  },
  props: {
        userId: 0,
        lang: {
            default: '',
            type: String
        },
        site: {
            default: '',
            type: String
        }
  },
  methods: {
    remove(id) {
            if (window.app.sweetalert) {
                window.app.sweetalert(this.locales.properties.are_you_sure_you_want_to_remove_this_match, {
                    buttons: ['Cancel', 'Ok'],
                }).then(value => {
                    if (value) {
                        $.ajax({
                            url: `/api/matches/delete/${id}/${this.userId}`,
                            method: 'delete',
                            success: (response) => {
                                this.$store.commit('SET_PROPERTIES_COLLECTION', response);
                                if(response.length<1){
                                    $('.properties').append('<span>'+this.locales.properties.there_are_no_matches_yet+'</span>');
                                }
                                window.app.sweetalert(this.locales.common.success,this.locales.properties.match_removed, 'success');
                            },
                            error: () => {
                                window.app.sweetalert('Oops!', 'Error deleting', 'error');
                            }
                        });
                    }
                })
            }
        }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/MatchesListing.vue